/**
 * Bottom Buttons Container
 *
 * Flex container for the language, rules, attributions, and version buttons
 * in the bottom-left corner.
 */

import React, { useState } from 'react';
import { useTranslation } from '../i18n/index.js';
import { VERSION } from '../version.js';
import RulesModal from './RulesModal.jsx';
import ChangelogModal from './ChangelogModal.jsx';
import AttributionsModal from './AttributionsModal.jsx';
import './BottomButtons.css';

export default function BottomButtons() {
  const { t, language, setLanguage } = useTranslation();
  const [showRulesModal, setShowRulesModal] = useState(false);
  const [showChangelogModal, setShowChangelogModal] = useState(false);
  const [showAttributionsModal, setShowAttributionsModal] = useState(false);

  const isDevMode = window.location.pathname.includes('/dev');

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'de' : 'en');
  };

  return (
    <>
      <div className="bottom-buttons">
        <button
          className="bottom-btn"
          onClick={toggleLanguage}
          title={language === 'en' ? 'Wechseln zu Deutsch' : 'Switch to English'}
        >
          {language === 'en' ? 'DE' : 'EN'}
        </button>
        <button
          className="bottom-btn"
          onClick={() => setShowRulesModal(true)}
          title={t('rules.buttonTitle')}
        >
          ?
        </button>
        <button
          className="bottom-btn info-btn"
          onClick={() => setShowAttributionsModal(true)}
          title={t('attributions.buttonTitle')}
        >
          &#9432;
        </button>
        <button
          className="bottom-btn"
          onClick={() => setShowChangelogModal(true)}
          title={t('changelog.buttonTitle')}
        >
          v{VERSION}
        </button>
        <a
          className="bottom-btn"
          href={isDevMode ? '/online.html' : '/dev'}
          title={t(isDevMode ? 'mode.switchToOnline' : 'mode.switchToDev')}
        >
          {isDevMode ? '🌐' : '🔧'}
        </a>
      </div>

      {showRulesModal && (
        <RulesModal onClose={() => setShowRulesModal(false)} />
      )}

      {showChangelogModal && (
        <ChangelogModal onClose={() => setShowChangelogModal(false)} />
      )}

      {showAttributionsModal && (
        <AttributionsModal onClose={() => setShowAttributionsModal(false)} />
      )}
    </>
  );
}
